import {
    getFeedbackFilterRepo, getFeedbackListRepo, postFeedbackListRepo, 
    getFeedbackDetailRepo, putFeedbackDetailRepo, putFeedbackMappedStatusRepo,
} from "../repositories/tools/CP_feedbackTool";
import { createSlice } from "@reduxjs/toolkit";

const feedbackSlice = createSlice({
    name: "feedbackReducer",
    initialState: {
// Filter initialStates
        productFilterLoading:null,
        productFilterData: null,
        productFilterError: null,

        feedbackTypeFilterLoading:null,
        feedbackTypeFilterData:null,
        feedbackTypeFilterError:null,
        
// List initialState
        feedbackListLoading: null,
        feedbackListData: null,
        feedbackListError: null,

        feedbackListUnMappedLoading: null,
        feedbackListUnMappedData: null,
        feedbackListUnMappedError: null,

        postFeedbackListUnMappedLoading: null,
        postFeedbackListUnMappedData: null,
        postFeedbackListUnMappedError: null,

        postFeedbackListLoading: null,
        postFeedbackListData: null,
        postFeedbackListError: null,
        
// Detail initialState
        feedbackDetailLoading:null,
        feedbackDetailData: null,
        feedbackDetailError: null,

        putFeedbackDetailLoading: null,
        putFeedbackDetailData: null,
        putFeedbackDetailError: null,

// Mapped Status
        putFeedbackMappedStatusLoading: null,
        putFeedbackMappedStatusData: null,
        putFeedbackMappedStatusError: null,

        message:null,
    },
    reducers: {
// Filter reducers
        getProductFilterLoading(state, action) {
            return {
                ...state,
                productFilterLoading: true,
            };
        },
        getProductFilterSuccess(state, action) {
            return {
                ...state,
                productFilterLoading: false,
                productFilterData: action.payload,
            };
        },
        getProductFilterFailure(state, action) {
            return {
                ...state,
                productFilterLoading: false,
                productFilterError: action.payload,
            };
        },

        getFeedbackTypeFilterLoading(state, action) {
            return {
                ...state,
                feedbackTypeFilterLoading: true,
            };
        },
        getFeedbackTypeFilterSuccess(state, action) {
            return {
                ...state,
                feedbackTypeFilterLoading: false,
                feedbackTypeFilterData: action.payload,
            };
        },
        getFeedbackTypeFilterFailure(state, action) {
            return {
                ...state,
                feedbackTypeFilterLoading: false,
                feedbackTypeFilterError: action.payload,
            };
        },
// List reducers
        getFeedbackListLoading(state, action) {
            return {
                ...state,
                feedbackListLoading: true,
            };
        },
        getFeedbackListSuccess(state, action) {
            return {
                ...state,
                feedbackListLoading: false,
                feedbackListData: action.payload,
            };
        },
        getFeedbackListFailure(state, action) {
            return {
                ...state,
                feedbackListLoading: false,
                feedbackListError: action.payload,
            };
        },
        clearFeedbackSuccess(state, action) {
            return {
                ...state,
                feedbackListData: null,
                feedbackListUnMappedData: null,
                feedbackListError:null,
                feedbackListUnMappedError:null,
            }
        },

        getFeedbackListUnMappedLoading(state, action) {
            return {
                ...state,
                feedbackListUnMappedLoading: true,
            };
        },
        getFeedbackListUnMappedSuccess(state, action) {
            return {
                ...state,
                feedbackListUnMappedLoading: false,
                feedbackListUnMappedData: action.payload,
            };
        },
        getFeedbackListUnMappedFailure(state, action) {
            return {
                ...state,
                feedbackListUnMappedLoading: false,
                feedbackListUnMappedError: action.payload,
            };
        },

        postFeedbackListLoading(state, action) {
                return {
                    ...state,
                    postFeedbackListLoading: true,
                };
            },
        postFeedbackListSuccess(state, action) {
                return {
                    ...state,
                    postFeedbackListLoading: false,
                    postFeedbackListData: action.payload,
                    message: "Data Added Successfully"

                };
            },
        postFeedbackListFailure(state, action) {
                return {
                    ...state,
                    postFeedbackListLoading: false,
                    postFeedbackListError: action.payload,
                    message: "Something Went Wrong"

                };
            },

        postFeedbackListUnMappedLoading(state, action) {
            return {
                ...state,
                postFeedbackListUnMappedLoading: true,
            };
        },
        postFeedbackListUnMappedSuccess(state, action) {
            return {
                ...state,
                postFeedbackListUnMappedLoading: false,
                postFeedbackListUnMappedData: action.payload,
                message: "Data Added Successfully"
            };
        },
        postFeedbackListUnMappedFailure(state, action) {
            return {
                ...state,
                postFeedbackListUnMappedLoading: false,
                postFeedbackListUnMappedError: action.payload,
                message: "Something Went Wrong"
            };
        },
// Detail reducers
        getFeedbackDetailLoading(state, action) {
            return {
                ...state,
                feedbackDetailLoading: true,
            };
        },
        getFeedbackDetailSuccess(state, action) {
            return {
                ...state,
                feedbackDetailLoading: false,
                feedbackDetailData: action.payload,
            };
        },
        getFeedbackDetailFailure(state, action) {
            return {
                ...state,
                feedbackDetailLoading: false,
                feedbackDetailError: action.payload,
            };
        },
        clearFeedbackDetailSuccess(state,action){
            return {
                ...state,
                feedbackDetailData:null,
                feedbackDetailError:null,
            }
        },

        putFeedbackDetailLoading(state, action) {
            return {
                ...state,
                putFeedbackDetailLoading: true,
            };
        },
        putFeedbackDetailSuccess(state, action) {
            return {
                ...state,
                putFeedbackDetailLoading: false,
                putFeedbackDetailData: action.payload,
                message:"Data Updated Successfully"
            };
        },
        putFeedbackDetailFailure(state, action) {
            return {
                ...state,
                putFeedbackDetailLoading: false,
                putFeedbackDetailError: action.payload,
                message: "Something Went Wrong",
            };
        },
// Mapped Status
        putFeedbackMappedStatusLoading(state, action) {
            return {
                ...state,
                putFeedbackMappedStatusLoading: true,
            };
        },
        putFeedbackMappedStatusSuccess(state, action) {
            return {
                ...state,
                putFeedbackMappedStatusLoading: false,
                putFeedbackMappedStatusData: action.payload,
                message: "Data Updated Successfully"

            };
        },
        putFeedbackMappedStatusFailure(state, action) {
            return {
                ...state,
                putFeedbackMappedStatusLoading: false,
                putFeedbackMappedStatusError: action.payload,
                message: "Something Went Wrong",
            };
        },

        clearMessage(state, action) {
            return {
                ...state,
                message: null,
                postFeedbackListData:null,
                postFeedbackListUnMappedData: null,
                postFeedbackListError:null,
                postFeedbackListUnMappedError:null,
                putFeedbackMappedStatusData:null,
                putFeedbackMappedStatusError:null,
                putFeedbackDetailData:null,
                putFeedbackDetailError:null,
            }
        }
    },
});
export const {
    getProductFilterLoading,
    getProductFilterSuccess,
    getProductFilterFailure,

    getFeedbackTypeFilterLoading,
    getFeedbackTypeFilterSuccess,
    getFeedbackTypeFilterFailure,
   
    getFeedbackListLoading,
    getFeedbackListSuccess,
    getFeedbackListFailure,

    clearFeedbackSuccess,
    getFeedbackListUnMappedLoading,
    getFeedbackListUnMappedSuccess,
    getFeedbackListUnMappedFailure,

    postFeedbackListLoading,
    postFeedbackListSuccess,
    postFeedbackListFailure,

    postFeedbackListUnMappedLoading,
    postFeedbackListUnMappedSuccess,
    postFeedbackListUnMappedFailure,
    
    getFeedbackDetailLoading,
    getFeedbackDetailSuccess,
    getFeedbackDetailFailure,
    clearFeedbackDetailSuccess,

    putFeedbackDetailLoading,
    putFeedbackDetailSuccess,
    putFeedbackDetailFailure,

    putFeedbackMappedStatusLoading,
    putFeedbackMappedStatusSuccess,
    putFeedbackMappedStatusFailure,

    clearMessage,

} = feedbackSlice.actions;

// product filter
export const getProductFilter = (params) => {
    return async (dispatch) => {
        dispatch(getProductFilterLoading());
        await getFeedbackFilterRepo(params)
            .then((response) => {
                if (response?.status >= 200 && response?.status <= 300) {
                    dispatch(getProductFilterSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getProductFilterFailure(error.message));
                }
            });
    };
};


// Feedback Type filter
export const getFeedbackType = (params) => {
    return async (dispatch) => {
        dispatch(getFeedbackTypeFilterLoading());
        await getFeedbackFilterRepo(params)
            .then((response) => {
                if (response?.status >= 200 && response?.status <= 300) {
                    dispatch(getFeedbackTypeFilterSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getFeedbackTypeFilterFailure(error.message));
                }
            });
    };
};

// List 
export const getFeedbackList = (params) => {
    return async (dispatch) => {
        dispatch(getFeedbackListLoading());
        await getFeedbackListRepo(params)
            .then((response) => {
                if (response?.status >= 200 && response?.status <= 300) {
                    dispatch(getFeedbackListSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getFeedbackListFailure(error.message));
                }
            });
    };
};

export const getFeedbackUnMappedList = (params) => {
    return async (dispatch) => {
        dispatch(getFeedbackListUnMappedLoading());
        await getFeedbackListRepo(params)
            .then((response) => {
                if (response?.status >= 200 && response?.status <= 300) {
                    dispatch(getFeedbackListUnMappedSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(postFeedbackListUnMappedFailure(error.message));
                }
            });
    };
};

export const postFeedbackList = (params) => {
    return async (dispatch) => {
        dispatch(postFeedbackListLoading());
        await postFeedbackListRepo(params)
            .then((response) => {
                if (response?.status >= 200 && response?.status <= 300) {
                    dispatch(postFeedbackListSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(postFeedbackListFailure(error.message));
                }
            });
    };
};

export const postFeedbackListUnMapped = (params) => {
    return async (dispatch) => {
        dispatch(postFeedbackListUnMappedLoading());
        await postFeedbackListRepo(params)
            .then((response) => {
                if (response?.status >= 200 && response?.status <= 300) {
                    dispatch(postFeedbackListUnMappedSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(postFeedbackListUnMappedFailure(error.message));
                }
            });
    };
};

// detail
export const getFeedbackDetail = (id,params) => {
    return async (dispatch) => {
        dispatch(getFeedbackDetailLoading());
        await getFeedbackDetailRepo(id,params)
            .then((response) => {
                if (response?.status >= 200 && response?.status <= 300) {
                    dispatch(getFeedbackDetailSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getFeedbackDetailFailure(error.message));
                }
            });
    };
};

export const putFeedbackDetail = (id, data) => {
    return async (dispatch) => {
        dispatch(putFeedbackDetailLoading());
        await putFeedbackDetailRepo(id, data)
            .then((response) => {
                if (response?.status >= 200 && response?.status <= 300) {
                    dispatch(putFeedbackDetailSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(putFeedbackDetailFailure(error.message));
                }
            });
    };
};

export const putFeedbackMappedStatus = (params, data) => {
    return async (dispatch) => {
        dispatch(putFeedbackMappedStatusLoading());
        await putFeedbackMappedStatusRepo(params, data)
            .then((response) => {
                if (response?.status >= 200 && response?.status <= 300) {
                    dispatch(putFeedbackMappedStatusSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(putFeedbackMappedStatusFailure(error.message));
                }
            });
    };
};
export default feedbackSlice.reducer;